import styled from "styled-components";
import { TextBase } from "components";

import { mobile } from "styles/breakpoints";

export const ExtraSmallParagraph = styled(TextBase)`
  font-size: 0.88rem;
  line-height: 1.38rem;

  @media ${mobile} {
    font-size: 0.75rem;
    line-height: 1.25rem;
  }
`;